export default __webpack_public_path__ + "static/media/LogoADportalMini.606da8af.png";